import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DireccionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DIRECCION' htmlFor='input-direccion' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='direccion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-direccion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DireccionFormGroup)
